import { defineMessages } from '@transcend-io/internationalization';

export const headerMessages = defineMessages(
  'privacy-center.containers.Header.header',
  {
    /** The organization's logo */
    organizationLogoAlt: {
      defaultMessage: '{organizationName} logo',
    },
    /** The default logo */
    transcendLogoAlt: {
      defaultMessage: 'Transcend Logo',
    },
  },
);
